import { render } from "./TakeOverConfirmModal.vue?vue&type=template&id=0975da53"
import script from "./TakeOverConfirmModal.vue?vue&type=script&lang=js"
export * from "./TakeOverConfirmModal.vue?vue&type=script&lang=js"

import "./TakeOverConfirmModal.vue?vue&type=style&index=0&id=0975da53&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__